import classNames from 'classnames';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { BtnSingProps } from 'eco-design-micro/props/btn/BtnSingProps';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { TitleDescProps } from 'eco-design-micro/props/msg/TitleDescProps';
import { PriceProps } from 'eco-design-micro/props/price/PriceProps';
import getLocal from 'eco-design-reliance/getLocal';
import EcoButton from 'eco-design/base/eco-button';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTitle from 'eco-design/base/eco-title';
import React, { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import './index.scss';
import { LangText } from './LangText';
import TabsBox from './TabsBox';

export interface EcoAccessoriesItemProps extends TitleDescProps, PriceProps, ImgVideoProps, BtnSingProps {
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 库存
     */
    inventoryQuantity?: number;
    /**
     * noPrefix 无需价格前缀
     */
    noPrefix?: boolean;
    priceSuffix?: string;
    soldOut?: string;
}
export interface EcoAccessoriesProps {
    /**
     * 标题
     */
    title?: string;
    /**
     * 背景色
     */
    items?: EcoAccessoriesItemProps[];
    /**
     * 自定义类名
     */
    className?: string;
    /**
     * 点击图片视频
     */
    onClickImgVideo?: (item: EcoAccessoriesItemProps) => void;
}

/**
 * 配件列表
 */
const EcoAccessories: React.FC<EcoAccessoriesProps> = ({ title, onClickImgVideo, items = [], className }) => {
    const prefixCls = `eco-accessories`;
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const { locale = 'us' } = getLocal();
    const TextA = LangText[locale] || LangText['us'];
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);
    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={compCls}>
            <EcoTitle title={title} className={`eco-content ${prefixCls}-title`} />
            <Swiper
                className={`${prefixCls}-items`}
                slidesPerView={'auto'}
                spaceBetween={spaceBetweenN}
                navigation={{
                    nextEl: '.eco-swiper-button-next',
                    prevEl: '.eco-swiper-button-prev',
                }}
                modules={[Navigation]}
            >
                {items.map((item: EcoAccessoriesItemProps, index: number) => {
                    const { title, desc, price = 0, comparePrice, soldOut, noPrefix, priceSuffix } = item;
                    const soldOutBtn = Number(item?.inventoryQuantity || 0) <= 0 ? soldOut || TextA.soldOut : item?.lChildren || undefined;
                    return (
                        <SwiperSlide key={index} className={`${prefixCls}-item`}>
                            {item.children ? (
                                <TabsBox item={item} idx={index} onClickImgVideo={onClickImgVideo} />
                            ) : (
                                <>
                                    <div onClick={() => onClickImgVideo?.(item)}>
                                        <EcoImgVideo isVideo={item.isVideo} pc={item.pc} className={`${prefixCls}-item-img`} />
                                    </div>
                                    <div className={`${prefixCls}-item-msg`}>
                                        <div className={`${prefixCls}-item-title`}>{title}</div>
                                        <div className={`${prefixCls}-item-desc`}>{desc}</div>
                                        <div className={`${prefixCls}-item-price-box`}>
                                            {price > 0 && (
                                                <div className={`${prefixCls}-item-price-box-price`}>
                                                    {!noPrefix && TextA.priceMsA1} {FormatMoneyLocal(price, locale)}
                                                    {priceSuffix}
                                                </div>
                                            )}
                                            {Number(comparePrice) > 0 && price !== comparePrice && price > 0 && (
                                                <div className={`${prefixCls}-item-price-box-comparePrice`}>
                                                    {!noPrefix && TextA.priceMsB1} {FormatMoneyLocal(Number(comparePrice), locale)}
                                                </div>
                                            )}
                                        </div>
                                        <div className={`${prefixCls}-item-btn-box`}>
                                            <EcoButton
                                                lRadius="ellipse"
                                                lSize="large"
                                                lDataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item?.title,
                                                    position: `Product Detail_${index + 1}`,
                                                }}
                                                {...item}
                                                lChildren={soldOutBtn}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </SwiperSlide>
                    );
                })}
                <div className={`eco-swiper-control`}>
                    <div className="eco-swiper-navigation">
                        <div className="eco-swiper-button-prev">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                        <div className="eco-swiper-button-next">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                    </div>
                </div>
            </Swiper>
        </div>
    );
};

export default EcoAccessories;
